import { ProactiveOptions } from './chat-rule.model';

export class Options extends ProactiveOptions {
    SessionId: string;
    Location: string;
    DefaultSkillId: string;
    DefaultSkillAddressName: string;
}
